import project from './project/router'
import device from './device/router'
import user from './user/router'
import system from './system/router'
import trouble from "./trouble/router";
import statistics from "./statistics/router";
import template from "./template/router";
import task from "./task/router";
export default [
    {
        path: '/login',
        name: 'login',
        component: r => require.ensure([], () => r(require('./login/index.vue')), 'login'),
    },
    {
        path: '/',
        name: 'home',
        component: r => require.ensure([], () => r(require('./home/index.vue')), 'home'),
        children: [
            ...project,
            ...device,
            ...trouble,
            ...user,
            ...statistics,
            ...template,
            ...system,
            ...task
        ]
    },
]
